<template>
  <div>
    <b-modal
      v-model="showModal"
      ref="alertModal"
      hide-header
      hide-footer
      centered
      size="md"
    >
      <div class="modal-header">
        <div class="d-flex justify-content-between w-100">
          <div class="py-2">
            <h4>Reset Password</h4>
          </div>
          <button type="button" aria-label="Close" class="btn" @click="hide">
            <font-awesome-icon icon="times" title="Delete" />
          </button>
        </div>
      </div>
      <div class="">
        <b-row>
          <b-col>
            <div class="position-relative">
              <InputText
                textFloat="New Password"
                placeholder="New Password"
                type="password"
                name="password"
                isRequired
                v-model="form.password"
                :isValidate="$v.form.password.$error"
                :v="$v.form.password"
              />
              <label class="text-warning-message position-absolute">
                ({{ $t("warningPassword1") }})
              </label>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <InputText
              class="mt-3"
              textFloat="Confirm New Password"
              placeholder="Confirm New Password"
              type="password"
              name="password"
              isRequired
              v-model="form.confirmPassword"
              :isValidate="$v.form.confirmPassword.$error"
              :v="$v.form.confirmPassword"
            />
          </b-col>
        </b-row>

        <b-row class="mt-4">
          <b-col md="6">
            <b-button
              :disabled="isDisable"
              @click="hide()"
              class="btn-details-set btn-cancel"
              >CANCEL</b-button
            >
          </b-col>
          <b-col md="6" class="text-sm-right">
            <button
              type="button"
              @click="checkForm()"
              :disabled="isDisable"
              class="btn btn-main btn-details-set ml-md-2 text-uppercase"
            >
              SUBMIT
            </button>
          </b-col>
        </b-row>
      </div>
      <ModalLoading ref="modalLoading" :hasClose="false" />
    </b-modal>
  </div>
</template>

<script>
import { required, minLength, helpers, sameAs } from "vuelidate/lib/validators";

const password = helpers.regex(
  "password",
  /^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9!-_]+)$/
);
import InputText from "@/components/inputs/InputText";
import ModalLoading from "@/components/modal/alert/ModalLoading";

export default {
  components: {
    InputText,
    ModalLoading,
  },
  props: {
    userData: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      showModal: false,
      isDisable: false,
      form: {
        userGUID: "",
        password: "",
        confirmPassword: "",
      },
    };
  },
  validations: {
    form: {
      password: {
        required,
        password,
        minLength: minLength(8),
      },
      confirmPassword: {
        required,
        password,
        minLength: minLength(8),
        sameAsPassword: sameAs("password"),
      },
    },
  },
  methods: {
    checkForm: async function () {
      this.form.userGUID = this.userData.userGUID;
      this.$v.form.$touch();
      if (this.$v.form.$error) return;
      this.submit();
    },
    submit: async function () {
      this.isDisable = true;
      this.$refs.modalLoading.show();
      let data = {
        userGUID: this.form.userGUID,
        password: this.form.password,
      };
      await this.axios
        .post(`${this.$baseUrl}/user/ResetPassword`, data)
        .then((data) => {
          this.$refs.modalLoading.hide();
          if (data.result == 1) {
            this.redirecId = data.detail;
            this.$store.commit("UPDATE_GLOBAL_ALERT", {
              isShow: true,
              msg: "สำเร็จ",
            });
            this.$emit("setNewPassword", this.form.password);
            setTimeout(() => {
              this.hide();
            }, 3000);
          } else {
            this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
              isShow: true,
              msg: data.message,
            });
          }
          this.isDisable = false;
        });
    },
    show() {
      this.form = {
        userGUID: "",
        currentPassword: "",
        newPassword: "",
      };
      this.$v.form.$reset();
      this.showModal = true;
    },
    hide() {
      this.showModal = false;
    },
  },
};
</script>

<style scoped>
.modal-header {
  border: 0 !important;
  padding: 0;
}
.text-text {
  color: #242424;
  margin-bottom: 0;
  font-size: 26px;
}
.modal-body {
  margin: auto;
  text-align: center;
}
.img {
  width: 100px;
}

.text-warning-message {
  color: #bebebe;
  font-size: 11px;
  bottom: -26px;
}
@media (max-width: 767.98px) {
}
</style>
